module.exports = __webpack_public_path__ + "static/media/control-panel-icon.6ab13e8f.png";